// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: "https://devapi.hit2open.com/api/v1/",
  imageUrl: "https://devapi.hit2open.com/",
  shopUrl: 'https://devwebapp.hit2open.com/qr?shopId=',
  apiKey:'AIzaSyB64E05RIf1JNgdVAFnhWB-dHUwe7T_m48',
  /** POS terminal health — tune thresholds here (fractions, e.g. 0.05 = 5%). */
  terminalHealth: {
    reassuringRateFloor: 0.05,
    rateColorElevated: 0.05,
    rateColorWarn: 0.15,
    rateColorBad: 0.25,
    rateColorCritical: 0.50,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
